"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Badge = _interopRequireDefault(require("../Badge"));

var _ContentEditable = _interopRequireDefault(require("../ContentEditable"));

var _forwardRef = _interopRequireDefault(require("../HOC/forwardRef"));

var _TextField = _interopRequireDefault(require("./TextField.style"));

var _PortalWrapper = _interopRequireDefault(require("../PortalWrapper"));

var _dec, _class;

const ContentEditCom = (0, _forwardRef.default)(_ContentEditable.default);
let TextField = (_dec = (0, _reactJss.default)(_TextField.default), _dec(_class = (0, _reactClickOutside.default)(_class = class TextField extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: !!props.value,
      passShow: false,
      focus: false,
      error: !!props.value,
      autoSelected: false
    };
    this.togglePass = this.togglePass.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChangeMult = this.handleChangeMult.bind(this);
    this.inputRef = props.forwardRef || _react.default.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    if (state.selected && !props.value || !state.selected && props.value) {
      return {
        selected: !!props.value
      };
    }

    return null;
  }

  componentDidMount() {
    const {
      autoFocus
    } = this.props;
    if (autoFocus) this.handleFocus();
  } // Получить value поля ввода


  getInputElValue() {
    const {
      multiline
    } = this.props;
    return multiline ? this.inputRef.innerHTML : this.inputRef.value;
  } // Handler for click outside of component


  handleClickOutside(e) {
    if (this.txtEl && this.txtEl.contains(e.target)) return;
    const {
      id,
      value,
      error,
      type,
      onBlur,
      onChange,
      calendar
    } = this.props;
    const {
      focus
    } = this.state;

    if (!value && !this.getInputElValue()) {
      this.setState({
        selected: false
      });
    }

    if (focus && !calendar) {
      this.setState({
        focus: false
      });
    } // trim value


    const trimTypes = ['text', 'email'];

    if (value && typeof value === 'string' && trimTypes.includes(type) && value !== value.trim()) {
      onChange({
        id,
        value: value.trim(),
        error
      });
    }

    onBlur();
  } // get input type


  getInputType(type, passShow) {
    if (type === 'int' || type === 'float') return 'number';
    return type === 'password' && !passShow ? 'password' : 'text';
  } // focus for field


  handleFocus() {
    const {
      visibility,
      onFocus,
      id,
      autoSelect,
      toggleFocus
    } = this.props;
    const {
      autoSelected,
      focus
    } = this.state;
    if (visibility !== 'visible') return;
    if (!toggleFocus) this.inputRef.current.focus();

    if (autoSelect && !autoSelected) {
      setTimeout(() => {
        if (this.inputRef.current) this.inputRef.current.select();
      }, 0);
    }

    this.setState({
      selected: true,
      focus: true,
      autoSelected: autoSelect ? !autoSelected : false
    });

    if (toggleFocus && focus) {
      this.handleBlur();
    } else {
      onFocus(id);
    }
  } // blur for field


  handleBlur() {
    const {
      calendar,
      value,
      visibility,
      onBlur,
      id,
      colorPicker
    } = this.props;
    if (visibility !== 'visible') return;
    this.inputRef.current.blur();

    if (!calendar && !colorPicker) {
      this.setState({
        selected: Boolean(value) || false,
        focus: false
      });
    }

    onBlur(id);
  } // Handle change for single line field


  handleChange(e) {
    const {
      id,
      onChange
    } = this.props;
    const {
      error,
      value
    } = this.formatAndCheck(e.target.value);
    onChange({
      id,
      value,
      error
    });
  } // Handle change for multiple line field


  handleChangeMult({
    value: multVal
  }) {
    const {
      id,
      onChange
    } = this.props;
    const {
      error,
      value
    } = this.formatAndCheck(multVal);
    onChange({
      id,
      value,
      error
    });
  }

  formatAndCheck(value) {
    let error = false;
    const {
      regexp,
      type,
      length,
      required
    } = this.props;

    if (type === 'email') {
      // eslint-disable-next-line max-len
      const re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-line

      if (!re.test(String(value))) {
        error = true;
      }
    } // Formatting type int


    if (type === 'int' || type === 'phone' && /\D/g.test(value)) {
      value = value.replace(/\D/g, '');
    } // Formatting type float


    if (type === 'float') {
      value = value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1');
    } // Restriction by string length


    if (length && value.length >= length) {
      value = value.substr(0, length);
    } // check regexp


    if (regexp) {
      const r = new RegExp(regexp);
      error = !r.test(value.trim());
    }

    if (required && (!value || !value.length)) {
      error = true;
    }

    return {
      error,
      value
    };
  } // show/hide password


  togglePass() {
    const {
      passShow
    } = this.state;
    this.setState({
      passShow: !passShow
    });
  }

  handleClickRightIcon(e) {
    const {
      onClickRightIcon
    } = this.props;
    onClickRightIcon(e);
  } // Render fake input fields for disabling browser autocomplete


  renderFakePass() {
    if (this.props.type !== 'password') return null;
    return _react.default.createElement("div", {
      style: {
        display: 'none'
      }
    }, _react.default.createElement("input", {
      type: "text"
    }), _react.default.createElement("input", {
      type: "password"
    }));
  } // render icon on the left side


  renderIcon(icon, classes, position, error, handleClick) {
    if (!icon) return null;
    const {
      size,
      bordered
    } = this.props;
    return _react.default.createElement("div", {
      className: (0, _clsx.default)(classes[position], position)
    }, _react.default.createElement(_Icon.default, {
      type: icon,
      error: error,
      onClick: handleClick,
      size: bordered && size === 'small' ? 'small' : 'medium'
    }));
  } // render badge as color indicator


  renderColorBadge() {
    const {
      classes,
      value
    } = this.props;
    return _react.default.createElement(_Badge.default, {
      className: classes.colorBadge,
      size: "large",
      bgColor: value
    });
  } // render show\hide password button for text field's type password


  renderShowPassBtn(type, passShow, classes) {
    if (type !== 'password') return null;
    const {
      size,
      bordered
    } = this.props;
    const iconType = passShow ? 'no_eye' : 'eye';
    return _react.default.createElement(_Icon.default, {
      type: iconType,
      size: bordered && size === 'small' ? 'small' : 'medium',
      className: classes.passIcon,
      onClick: this.togglePass
    });
  } // render error message


  renderHelperText(error, helperText, classes) {
    if (!helperText) return null;
    return _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.helperText, {
        error
      })
    }, helperText);
  } // render Calendar or ColorPicker popup


  renderPopup(popupEl, classes) {
    const {
      focus
    } = this.state;
    const {
      onBlur,
      portalOptions
    } = this.props;
    let top = 10;

    if (this.field && window.innerHeight - this.field.offsetTop < 380) {
      top = window.innerHeight - this.field.offsetTop - 380;
    }

    if (!focus || !popupEl) return null;
    const popup = popupEl();

    const popupComponent = _react.default.cloneElement(popup, {
      onClose: () => {
        this.setState({
          focus: false
        });
        onBlur();
      }
    });

    return portalOptions ? _react.default.createElement(_PortalWrapper.default, (0, _extends2.default)({
      node: this.txtEl
    }, portalOptions), popupComponent) : _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.popup),
      style: {
        top
      }
    }, popupComponent);
  } // Отрисовать placeholder


  renderPlaceholder() {
    const {
      placeholder,
      size,
      label,
      bordered
    } = this.props;
    const {
      selected
    } = this.state;
    if (!placeholder) return null;
    if (size === 'small' || selected || !label && !selected || bordered) return placeholder;
  } // Отрисовать однострочное поле ввода


  renderInput() {
    const {
      type,
      visibility,
      value,
      onKeyPress,
      onKeyUp,
      onKeyDown,
      readOnly,
      inputMode
    } = this.props;
    const {
      passShow
    } = this.state;
    const tabIndex = visibility !== 'visible' ? -1 : 0;
    const style = {};

    if (readOnly || visibility !== 'visible') {
      style.pointerEvents = 'none';
    }

    return _react.default.createElement("input", {
      ref: this.inputRef,
      style: style,
      type: this.getInputType(type, passShow),
      inputMode: inputMode,
      value: value,
      onChange: this.handleChange,
      autoComplete: "off",
      disabled: visibility === 'disabled',
      readOnly: readOnly,
      tabIndex: tabIndex,
      placeholder: this.renderPlaceholder(),
      onKeyPress: onKeyPress,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      onBlur: this.handleBlur
    });
  }

  renderTextArea() {
    const {
      visibility,
      value,
      onKeyPress,
      onKeyUp,
      onKeyDown,
      readOnly,
      rows
    } = this.props;
    return _react.default.createElement("textarea", {
      ref: this.inputRef,
      value: value,
      rows: rows,
      onChange: this.handleChange,
      autoComplete: "off",
      disabled: visibility === 'disabled',
      readOnly: readOnly,
      placeholder: this.renderPlaceholder(),
      onKeyPress: onKeyPress,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      onBlur: this.handleBlur
    });
  } // Отрисовать многострочное поле ввода


  renderMultiline() {
    const {
      id,
      visibility,
      value,
      multilineType,
      onKeyPress,
      onKeyUp,
      onKeyDown,
      onUpload
    } = this.props;
    const tabIndex = visibility !== 'visible' ? -1 : 0;
    return multilineType === 'text' ? this.renderTextArea() : _react.default.createElement(ContentEditCom, {
      id: id,
      ref: this.inputRef,
      type: multilineType,
      visibility: visibility,
      onChange: this.handleChangeMult,
      onKeyPress: onKeyPress,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp,
      onUpload: onUpload,
      tabIndex: tabIndex,
      placeholder: this.renderPlaceholder(),
      value: value,
      onBlur: this.handleBlur
    });
  } // Отрисовать label


  renderLabel() {
    const {
      label,
      size,
      bordered,
      classes
    } = this.props;
    if (!bordered && size === 'small') return null;
    return _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.label, 'label'),
      onClick: this.handleFocus
    }, label);
  }

  render() {
    const {
      classes,
      className,
      id,
      type,
      size,
      visibility,
      error,
      rightIcon,
      helperText,
      calendar,
      colorPicker,
      multiline,
      bordered
    } = this.props;
    const {
      passShow,
      focus,
      selected
    } = this.state;
    let leftIcon = type === 'phone' ? 'plus' : this.props.leftIcon;
    leftIcon = calendar ? 'calendar' : leftIcon;
    return _react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(className, classes.txt, classes[size], {
        error: !!error
      }, {
        hidden: visibility === 'hidden'
      }, {
        disabled: visibility === 'disabled'
      }, {
        focus: !!focus
      }, {
        selected: !!selected
      }, {
        hasLeftIcon: !!leftIcon
      }, {
        bordered
      }),
      ref: el => {
        this.txtEl = el;
      }
    }, this.renderLabel(), _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.field, 'field'),
      onClick: this.handleFocus,
      ref: el => {
        this.field = el;
      }
    }, this.renderIcon(leftIcon, classes, 'leftIcon', error), colorPicker ? this.renderColorBadge() : null, multiline ? this.renderMultiline() : this.renderInput(), this.renderIcon(rightIcon, classes, 'rightIcon', error, this.handleClickRightIcon.bind(this)), this.renderShowPassBtn(type, passShow, classes), this.renderFakePass()), this.renderHelperText(error, helperText, classes), this.renderPopup(calendar || colorPicker, classes));
  }

}) || _class) || _class);
TextField.defaultProps = {
  type: 'text',
  size: 'medium',
  visibility: 'visible',
  error: false,
  location: 'en',
  calendar: null,
  colorPicker: null,
  multiline: false,
  multilineType: 'html',
  lineNumbers: 2,
  readOnly: false,
  toggleFocus: false,
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onClickRightIcon: () => {},
  onKeyPress: () => {},
  onKeyUp: () => {},
  onKeyDown: () => {},
  onUpload: () => {},
  bordered: false,
  inputMode: 'text'
};
var _default = TextField;
exports.default = _default;